import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import {
  PoseedorAdheridoControllerService,
  ReplicationRequestDTO,
  ReplicationResultDTO,
} from 'api-rest';
import { SnackbarService } from '../../../../services/snackbar.service';
import { SpinnerService } from '../../../../services/spinner.service';

@Component({
  selector: 'lib-replication-dialog',
  templateUrl: './replication-dialog.component.html',
  styleUrls: ['./replication-dialog.component.scss'],
})
export class ReplicationDialogComponent {

  proceso: any;
  formGroup!: FormGroup;

  aniosOrigen: number[] = [];
  aniosDestino: number[] = [];

  constructor(
    public dialogRef: MatDialogRef<ReplicationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private snackbarService: SnackbarService,
    public spinnerSrv: SpinnerService,
    private poseedorAdheridoService: PoseedorAdheridoControllerService,
  ) {
    this.proceso = this.data?.proceso;
  }

  ngOnInit(): void {
    const anioActual = new Date().getFullYear();
    this.aniosOrigen = [anioActual - 1, anioActual];
    this.aniosDestino = [anioActual, anioActual + 1];
    this.initializeForm();
  }

  initializeForm() {
    this.formGroup = this.formBuilder.group({
      anioOrigen: [null, Validators.required],
      anioDestino: [null, Validators.required],
    });
  }

  lanzarReplica() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid) {
      return;
    }

    const anioOrigen = this.formGroup.get('anioOrigen')?.value;
    const anioDestino = this.formGroup.get('anioDestino')?.value;

    Swal.fire({
      text: `¿Desea lanzar la réplica de ${this.proceso?.nombre} desde el año ${anioOrigen} al año ${anioDestino}?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.ejecutarReplica(anioOrigen, anioDestino);
      }
    });
  }

  ejecutarReplica(anioOrigen: number, anioDestino: number) {
    const replicationRequestDTO: ReplicationRequestDTO = {
      anioOrigen: anioOrigen,
      anioDestino: anioDestino,
    };

    this.spinnerSrv.loadingShow();
    this.poseedorAdheridoService.replicate(replicationRequestDTO).subscribe({
      next: (resultado: ReplicationResultDTO) => {
        this.spinnerSrv.loadingHide();
        this.snackbarService.showSnackBar(
          `Réplica finalizada: ${resultado?.replicados ?? 0} de ${resultado?.totalOrigen ?? 0} registros replicados`,
          'success'
        );
        this.dialogRef.close(true);
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackbarService.showSnackBar(
          'Se ha producido un error al lanzar la réplica',
          'error'
        );
      },
    });
  }

  cerrar(): void {
    this.dialogRef.close(null);
  }
}
